import { FilterConfig } from "../../../components/Tables/advancedRecord/FilterBar";
import { DropdownDTO } from "../../../types/common/DropdownDTO";

/**
 * 🎯 Filtros para tabla de eventos de contingencia
 */
export const getContingencyEventFilters = (
  statusDropdown: DropdownDTO[],
  createdByDropdown: DropdownDTO[]
): FilterConfig[] => {
  return [
    {
      name: "status",
      label: "Estado",
      type: "select",
      options: statusDropdown,
      colSpan: 4,
    },

    {
      name: "startDate",
      label: "Fecha Inicio",
      type: "date",
      colSpan: 3,
    },

    {
      name: "endDate",
      label: "Fecha Fin",
      type: "date",
      colSpan: 3,
    },

    {
      name: "createdBy",
      label: "Creado por",
      type: "searchSelect",
      options: createdByDropdown,
      colSpan: 2,
    },
  ];
};